/**
 * Accepted artwork file spec for the public/guest upload paths (Design & Order page's
 * placement uploads, Request-a-Quote modal). Matches backend/src/routes/design-uploads.routes.ts's
 * real constraints exactly — that route is unauthenticated (no login required to ask for a quote),
 * so it's deliberately narrower than the authenticated print-order upload (PrintOrderIntake.js,
 * via shared-ui's useFileUpload, which accepts PDF/AI/EPS too). Don't advertise formats this path
 * can't actually accept. See docs/NOOSA-ORDER-INTAKE-TASKS.md Task 2.
 */
export const ACCEPTED_ARTWORK_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const ACCEPTED_ARTWORK_ACCEPT_ATTR = 'image/png,image/jpeg,image/webp';
export const MAX_ARTWORK_SIZE_MB = 10;
export const ACCEPTED_ARTWORK_LABEL = 'PNG, JPG, or WebP — max 10MB';

export function validateArtworkFile(file) {
  if (!ACCEPTED_ARTWORK_MIME_TYPES.includes(file.type)) {
    return `We accept ${ACCEPTED_ARTWORK_LABEL.toLowerCase()}. Got: ${file.type || 'unknown type'}.`;
  }
  if (file.size > MAX_ARTWORK_SIZE_MB * 1024 * 1024) {
    return `File is too large — max ${MAX_ARTWORK_SIZE_MB}MB.`;
  }
  return null;
}
